import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../core/services/auth.service';

export interface InstallmentPayment {
  _id: string;
  amount: number;
  currency: string;
  method: string;
  status: string;
  receiptImage?: {
    secure_url: string;
    public_id: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface Installment {
  _id: string;
  installmentType: string;
  installmentNumber: number;
  amount: number;
  status: string;
  dealId: string;
  payment?: InstallmentPayment | null;
}

export interface InstallmentsSummary {
  totalInstallments: number;
  paidCount: number;
  upcomingCount: number;
  overdueCount: number;
  totalPaid: number;
  totalRemaining: number;
  nextDueDate: string | null;
  nextDueAmount: number;
}

export interface MyInstallmentsResponse {
  summary: InstallmentsSummary;
  installments: Installment[];
}

@Injectable({
  providedIn: 'root'
})
export class MyInstallmentsService {
  private baseUrl = environment.api.baseUrl;

  constructor(private http: HttpClient, private authService: AuthService) {}

  private headers(): HttpHeaders | undefined {
    const token = this.authService.getAccessToken();
    return token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;
  }

  getInstallments(): Observable<MyInstallmentsResponse> {
    return this.http.get<MyInstallmentsResponse>(`${this.baseUrl}/portal/my-installments`, {
      headers: this.headers()
    });
  }

  payInstallment(dealId: string, formData: FormData): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/payment/deal/${dealId}`, formData, {
      headers: this.headers()
    });
  }
}
